import { Box, Button, InputAdornment, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import MagnifierIcon from "../../shared/assets/icons/MagnifierIcon";
import colors from "../themes/colors";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import useTranslation from "../hooks/useTranslation";
import { dt } from "../themes/redesignTokens";

export interface GlobalSearchProps {
  placeholder?: string;
  width?: string;
  isBorderRadius?: boolean;
}

const GlobalSearch = ({ placeholder, width = "500px", isBorderRadius = false }: GlobalSearchProps) => {
  const navigate = useNavigate();
  const { translate: tCommon } = useTranslation("common");

  const [searchParams] = useSearchParams();
  const productNumber = searchParams.get("productNumber");
  const [searchValue, setSearchValue] = useState<string | undefined>();

  const handleSearchTextChange = (event: any) => {
    setSearchValue(event.target.value);
  };

  useEffect(() => {
    if (productNumber) {
      setSearchValue(productNumber);
    } else {
      setSearchValue(undefined);
    }
  }, [productNumber])

  const handlerSearch = () => {
    if (searchValue) {
      navigate({
        pathname: "/search",
        search: createSearchParams({
          productNumber: searchValue,
        }).toString(),
      });
    }
  };

  const onEnterSearch = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter") {
      handlerSearch();
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ display: "flex", alignItems: "stretch" }}>
        <TextField
          sx={{
            position: "relative",
            width: { width },
            ".MuiOutlinedInput-root":
            {
              background: "#ffffff",
            }
            ,
            "& .MuiOutlinedInput-input": {
              paddingRight: "110px"
            },
            "& .MuiInputAdornment-positionEnd": {
              position: "absolute",
              right: 0,
              top: 0,
              bottom: 0,
              margin: 0,
              padding: 0,
              display: "flex",
              alignItems: "stretch",
            }
          }}
          placeholder={placeholder}
          className="border-radius-search"
          value={searchValue}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <MagnifierIcon color={dt.blue} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <Button
                  variant="contained"
                  sx={{
                    minHeight: "46px",
                    minWidth: "110px",
                    boxShadow: "none",
                    '&:hover': { boxShadow: 'none' },
                    '&.MuiButton-root': {
                      borderRadius: isBorderRadius ? "0 6px 6px 0 !important" : "6px",
                    }
                  }}
                  onClick={handlerSearch}
                >
                  {tCommon("buttons.search")}
                </Button>
              </InputAdornment>
            )
          }}
          onChange={handleSearchTextChange}
          onKeyDown={onEnterSearch}
        />
      </Box>
    </Box>
  );
};

export default GlobalSearch;